export enum LS {
	CARTTOKEN = 'tokenCart',
	USER_SESSION = 'userSession',
	REDIRECT = 'redirect',
}
